import _ from 'lodash';

/**
 * 指定カウントが取得できるまで繰り返しロードを行う
 * @params loadItems {function} ロード処理 (offset) => { items, totalCount }
 * @params loadCount {int} 読み込むカウント
 * @params isLoadCompleted {bool} すでに最大まで読み込んでいるか
 * @params offset {int}
 */
const takeLoad = async (
  loadItems,
  loadCount,
  isLoadCompleted,
  offset = 0,
  unit = undefined
) => {
  let loadedCount = 0 + offset;
  let allItems = [];
  let takeCount = loadCount;
  let resultTotalCount = 0;
  let resultRest = null;
  while (true) {
    const limit = unit
      ? calcLimit(takeCount, loadedCount, loadCount, unit)
      : undefined;
    const { items, totalCount, ...rest } = await loadItems(loadedCount, limit);
    resultTotalCount = totalCount;
    resultRest = rest;
    if (isLoadCompleted && totalCount > takeCount) {
      // 最大まで読込済みで前回より合計数が増えている場合は最大まで読み込む
      takeCount = totalCount;
    }
    Array.prototype.push.apply(allItems, items);
    loadedCount += _.size(items);
    if (loadedCount >= takeCount || loadedCount >= totalCount) {
      break;
    }
  }
  const result = {
    allItems,
    totalCount: resultTotalCount,
    ...resultRest,
  };

  return result;
};

const calcLimit = (takeCount, offset, initMaxCount, unit) => {
  // 最大値を超える場合はunitを返す
  // 20件目まで登録中で21件目を新規追加した場合に「さらに表示する」を押すのではなく最初から表示させる
  if (takeCount > initMaxCount) {
    return unit;
  }

  // 10件目まで登録中で11件目を新規追加した場合
  const limit = takeCount - offset;
  if (limit === 0) {
    return unit;
  }
  return Math.ceil((takeCount - offset) / unit) * unit;
};

export default {
  takeLoad,
};



// WEBPACK FOOTER //
// ./src/services/utilities/ReloadHelper.js